var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M7 10.5c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3zm0-.89c1.166 0 2.11-.944 2.11-2.11S8.167 5.39 7 5.39s-2.11.944-2.11 2.11S5.833 9.61 7 9.61zm1.596 9.05c-.143.213-.33.395-.549.535-.881.564-2.065.324-2.643-.535C1.8 13.309 0 9.53 0 7.323 0 3.555 3.134.5 7 .5s7 3.055 7 6.823c0 2.207-1.801 5.986-5.404 11.337zm-.798-.51c3.502-5.202 5.247-8.864 5.247-10.827C13.045 4.068 10.34 1.43 7 1.43S.955 4.068.955 7.323c0 1.963 1.745 5.625 5.247 10.826.29.43.88.55 1.322.268.109-.07.202-.161.274-.268z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5.5 2.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#BAC1CF",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#82BB2F",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z",
    transform: "translate(-5.5 -2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.cc297b23bb011ae01113d454c8fe4a71.svg";
export { ForwardRef as ReactComponent };